import { render } from "./Sanctions.vue?vue&type=template&id=62bdcefd&scoped=true"
import script from "./Sanctions.vue?vue&type=script&lang=js"
export * from "./Sanctions.vue?vue&type=script&lang=js"

import "./Sanctions.vue?vue&type=style&index=0&id=62bdcefd&scoped=true&lang=css"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bdcefd"]])

export default __exports__